// src/components/staff/RoleDialog.jsx
import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
} from "@mui/material";

// Add the missing function
const getApiBaseUrl = () => process.env.REACT_APP_API_URL || "http://localhost:8000";

export default function RoleDialog({ open, onClose, onRoleAdded }) {
  const [roleName, setRoleName] = useState("");
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");

  const handleSave = async () => {
    if (!roleName.trim()) return;
    setLoading(true);
    try {
      const response = await fetch(`${getApiBaseUrl()}/api/staff/roles/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify({ name: roleName }),
      });
      if (!response.ok) throw new Error("Failed to create role");
      setRoleName("");
      onRoleAdded?.(); // refresh roles in parent
      onClose();
    } catch (error) {
      console.error("Error creating role:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Add New Role</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1 }}>
          <TextField
            label="Role Name"
            value={roleName}
            onChange={(e) => setRoleName(e.target.value)}
            fullWidth
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={!roleName.trim() || loading}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}